'use client';

import { useEffect } from 'react';

/**
 * Mount-time page entrance animation.
 *
 * Adds the `page-transition-in` class to `<html>` for 350ms so the route can
 * play a CSS enter transition, then removes it. Pairs with the
 * `page-transition-out` class applied by the outgoing route.
 *
 * Shared by the auth pages (login, register, reset-password/request) so the
 * identical useEffect isn't copy-pasted across each page — see PIERRE-1863.
 */
export function usePageTransition(): void {
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove('page-transition-out');
    root.classList.add('page-transition-in');

    const timer = setTimeout(() => {
      root.classList.remove('page-transition-in');
    }, 350);

    return () => clearTimeout(timer);
  }, []);
}
